import { createContext } from 'react'
import { ListContextProps } from '../types/list'

export const ListContext = createContext({} as ListContextProps)
